module.exports = __webpack_public_path__ + "static/media/29_tn.ee703796.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/29_tn.jpg
// module id = 517
// module chunks = 0